<template>
  <component
    :is="as"
    :class="{
      'font-semibold': selected,
      'rounded-full border border-brand-baby-blue bg-brand-hover-blue text-neutral-900 hover:bg-brand-baby-blue/50':
        variant === 'primary' && selected,
      'text-red-500 hover:bg-red-500 hover:text-red-50': variant === 'red',
      // Comboboxes (etc.) want to have complete control over the active state.
      // That includes mouse over. We don't want the CSS + JS controlled hover
      // states to clash, so we only enable CSS hover styles when `active` is not passed.
      'bg-neutral-200': active,
      'hover:bg-neutral-200': active === undefined,
      'pointer-events-none': disabled,
    }"
    class="q-focus flex w-full cursor-pointer items-center gap-2 overflow-clip rounded-full px-3 py-[9px] text-base text-neutral-700 transition-colors ui-focus-visible:z-10"
    :data-selected="selected"
    :disabled="disabled"
    :type="as === 'button' ? 'button' : undefined"
  >
    <div v-if="$slots['icon-custom-before']" class="shrink-0 empty:hidden">
      <slot name="icon-custom-before" />
    </div>
    <div v-if="$slots['icon-before']" class="grid h-4 w-4 shrink-0 items-center empty:hidden">
      <slot name="icon-before" />
    </div>
    <slot />
    <div
      v-if="$slots['icon-after']"
      class="ml-auto grid h-full w-4 shrink-0 items-center empty:hidden"
    >
      <slot name="icon-after" />
    </div>
  </component>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    as?: 'button' | 'a' | 'router-link' | 'div' | 'label'
    selected?: boolean
    disabled?: boolean
    active?: boolean | undefined
    variant?: 'primary' | 'red' | 'default'
  }>(),
  { as: 'button', variant: 'default', active: undefined }
)
</script>
